<div id="content-section">
  <div id="content-main" style="margin-right: 420px">
    <div id="content-sidebar" class="px-0" style="width: 400px; position: fixed; right: 20px">
      <h5 class="pt-1 px-3 pb-2">
        <div class="pull-right float-right">
          <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearSearch()">Clear</button>
        </div>
        <span>
          Search&nbsp;&nbsp;
          <a href="javascript: void(0)" title="Search" style="cursor: pointer" (click)="searching ? '' : search()"><i *ngIf="!searching" class="fas fa-arrow-circle-right"></i><i *ngIf="searching" class="fas fa-spinner fa-pulse fa-fw"></i></a>
        </span>
      </h5>
      <div class="px-3 text-center">
        <pagination
          [boundaryLinks]="true"
          [itemsPerPage]="search_options.per_page"
          [maxSize]="5"
          (pageChanged)="search($event)"
          [totalItems]="count"
          name='search_params_page'
          ngDefaultControl
          [(ngModel)]="search_params.page"
          class="pagination-sm"
          previousText="&lsaquo;"
          nextText="&rsaquo;"
          firstText="&laquo;"
          lastText="&raquo;"
        ></pagination>
        {{ count }} documents found
      </div>
      <div class="clearfix"></div>
      <hr class="my-1 mx-3" />
      <div id="search-form" class="px-3 py-2" style="overflow-y: scroll; border-bottom: 1px solid #ccc">
        <div class="form-group">
          <label class="col-form-label">Author</label>
          <app-author-search (author_id)="search_params.author_id = $event" (clearAuthor)="search_params.author_id = undefined"></app-author-search>
        </div>
        <div class="form-group">
          <label class="col-form-label">Recipient</label>
          <app-recipient-search (recipient_id)="search_params.recipient_id = $event" (clearRecipient)="search_params.recipient_id = undefined"></app-recipient-search>
        </div>
        <div class="form-group">
          <label class="col-form-label">Document Type</label>
          <app-document-type-search (document_type_id)="search_params.document_type_id = $event"></app-document-type-search>
        </div>
        <div class="form-group">
          <label class="col-form-label">Containing</label>
          <input name='search_params_contents' ngDefaultControl type="text" class="form-control" [(ngModel)]="search_params.contents" />
        </div>
        <div class="form-group">
          <label class="col-form-label">Notes</label>
          <input type="text" name="search_params_notes" ngDefaultControl class="form-control" [(ngModel)]="search_params.notes" />
        </div>
        <div class="form-group">
          <label class="col-form-label">Authored On</label>
          <div class="form-row mb-1">
            <div class="col-6 text-center"><label>From</label></div>
            <div class="col-6 text-center"><label>To</label></div>
          </div>
          <div class="form-row mb-1">
            <div class="col-6 text-center">
              <input name="authored_at_from" ngDefaultControl [appDatepicker] (dateSelected)="search_params.authored_at_from = $event" type="text" class="form-control" />
            </div>
            <div class="col-6 text-center">
              <input name="authored_at_to" ngDefaultControl [appDatepicker] (dateSelected)="search_params.authored_at_to = $event" type="text" class="form-control" />
            </div>
          </div>
        </div>
        <div class="form-group">
          <label class="col-form-label">Created On</label>
          <div class="form-row mb-1">
            <div class="col-6 text-center"><label>From</label></div>
            <div class="col-6 text-center"><label>To</label></div>
          </div>
          <div class="form-row mb-1">
            <div class="col-6 text-center">
              <input name="created_at_from" ngDefaultControl [appDatepicker] (dateSelected)="search_params.created_at_from = $event" type="text" class="form-control" />
            </div>
            <div class="col-6 text-center">
              <input name="created_at_to" ngDefaultControl [appDatepicker] (dateSelected)="search_params.created_at_to = $event" type="text" class="form-control" />
            </div>
          </div>
        </div>
        <div class="form-group">
          <label class="col-form-label">Tagged With</label>
          <input name="search_params_tags" ngDefaultControl type="text" class="form-control" [(ngModel)]="search_params.tags" />
        </div>
        <div class="form-group">
          <label class="col-form-label">Result Must Have</label>
          <div>
            <div class="custom-control custom-radio" (click)="search_params.tag_scope = 'All'">
              <input name="tags_scope" ngDefaultControl [checked]="search_params.tag_scope == 'All'" type="radio" name="tagScope" class="custom-control-input" value="All" />
              <label class="custom-control-label">Only</label>
            </div>
            <div class="custom-control custom-radio" (click)="search_params.tag_scope = 'Any'">
              <input name="tags_scope" ngDefaultControl [checked]="search_params.tag_scope == 'Any'" type="radio" name="tagScope" class="custom-control-input" value="Any" />
              <label class="custom-control-label">Any</label>
            </div>
            <div class="custom-control custom-radio" (click)="search_params.tag_scope = 'Like'">
              <input name="tags_scope" ngDefaultControl [checked]="search_params.tag_scope == 'Like'" type="radio" name="tagScope" class="custom-control-input" value="Like" />
              <label class="custom-control-label">Like</label>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="custom-control custom-checkbox" (click)="search_params.tag_ownership = !search_params.tag_ownership">
            <input name="tag_ownership" ngDefaultControl [checked]="search_params.tag_ownership" type="checkbox" class="custom-control-input" [(ngModel)]="search_params.tag_ownership" />
            <label class="custom-control-label">Only My Tags</label>
          </div>
        </div>
        <div class="form-group text-center">
          <button type="button" class="btn btn-primary" [disabled]="searching" (click)="search()">
            {{ searching ? 'Searching' : 'Search' }}<span *ngIf="searching">&nbsp;<i class="fas fa-spinner fa-fw fa-pulse"></i></span>
          </button>
        </div>
      </div>
    </div>
    <div id="content-inner" style="padding: 10px 20px 10px 20px">
      <div class="container-fluid container-shadow py-3 px-3">
        <div class="row">
          <div class="col-sm-4"><h6 class="text-center">Matter</h6></div>
          <div class="col-sm-2"><h6>Document</h6></div>
          <div class="col-sm-2"><h6>Type</h6></div>
          <div class="col-sm-2"><h6>Author</h6></div>
          <div class="col-sm-1"><h6>Authored</h6></div>
          <div class="col-sm-1"><h6>Created</h6></div>
        </div>
        <div *ngFor="let doc of documents; let o = odd">
          <div class="row" [ngClass]="{ 'bg-light': o }">
            <div class="col-sm-4">
              <a [routerLink]="'/matters/' + doc.matter_id">{{ doc.matter_name }}</a>
            </div>
            <div class="col-sm-2" (mouseenter)="doc.hovering_name = true" (mouseleave)="doc.hovering_name = false">
              <a [href]="'/documents/' + doc.id + '/download'" [title]="(doc.document_type || '') + (doc.document_type && doc.notes ? ' — ' : '') + (doc.notes || '')">{{ doc.name }}&nbsp;<i class="fas fa-file-pdf-o text-danger"></i></a>
              <span *ngIf="doc.hovering_name">
                &nbsp;|&nbsp;<a [routerLink]="'/matters/' + doc.matter_id" [queryParams]="{ document_id: doc.id, show: true, document_name: doc.name }"><i class="far fa-folder-open"></i></a>&nbsp;|&nbsp;<a [routerLink]="'/matters/' + doc.matter_id" [queryParams]="{ document_id: doc.id, edit: true }"
                  ><i class="fas fa-pencil-alt"></i
                ></a>
              </span>
            </div>
            <div class="col-sm-2">
              {{ doc.document_type }}
            </div>
            <div class="col-sm-2">
              <div *ngFor="let author_id of doc.author_ids; let i = index">
                <a [href]="'/contacts/' + author_id">{{ doc.authors[i] }}</a>
              </div>
            </div>
            <div class="col-sm-1">
              {{ doc.authored_at_2 }}
            </div>
            <div class="col-sm-1">
              {{ doc.created_at_2 }}
            </div>
          </div>
          <div class="row" [ngClass]="{ 'bg-light': o }">
            <div class="col-12" [innerHTML]="doc.notes | safeHtml"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
